export const GET_DESIGNS = "GET_DESIGNS"
export const GET_DESIGNS_SUCCESS = "GET_DESIGNS_SUCCESS"
export const GET_DESIGNS_FAIL = "GET_DESIGNS_FAIL"

export const ADD_DESIGN = "ADD_NEW_DESIGN"
export const ADD_DESIGN_SUCCESS = "ADD_DESIGN_SUCCESS"
export const ADD_DESIGN_FAIL = "ADD_DESIGN_FAIL"

export const UPDATE_DESIGN = "UPDATE_DESIGN"
export const UPDATE_DESIGN_SUCCESS = "UPDATE_DESIGN_SUCCESS"
export const UPDATE_DESIGN_FAIL = "UPDATE_DESIGN_FAIL"

export const DELETE_DESIGN = "DELETE_DESIGN"
export const DELETE_DESIGN_SUCCESS = "DELETE_DESIGN_SUCCESS"
export const DELETE_DESIGN_FAIL = "DELETE_DESIGN_FAIL"

export const GET_CUSTOM_CLIMATE = "GET_CUSTOM_CLIMATE"
export const GET_CUSTOM_CLIMATE_SUCCESS = "GET_CUSTOM_CLIMATE_SUCCESS"
export const GET_CUSTOM_CLIMATE_FAIL = "GET_CUSTOM_CLIMATE_FAIL"

export const SAVE_CLIMATE_DATA = "SAVE_CLIMATE_DATA"
export const SAVE_CLIMATE_DATA_SUCCESS = "SAVE_CLIMATE_DATA_SUCCESS"
export const SAVE_CLIMATE_DATA_FAIL = "SAVE_CLIMATE_DATA_FAIL"

export const GET_CLIMATE_DATA = "GET_CLIMATE_DATA"
export const GET_CLIMATE_DATA_SUCCESS = "GET_CLIMATE_DATA_SUCCESS"
export const GET_CLIMATE_DATA_FAIL = "GET_CLIMATE_DATA_FAIL"

export const GET_FREEBIE_CLIMATE_DATA = "GET_FREEBIE_CLIMATE_DATA"
export const GET_FREEBIE_CLIMATE_DATA_SUCCESS = "GET_FREEBIE_CLIMATE_DATA_SUCCESS"
export const GET_FREEBIE_CLIMATE_DATA_FAIL = "GET_FREEBIE_CLIMATE_DATA_FAIL"

export const PLANT_SEARCH = "PLANT_SEARCH"
export const PLANT_SEARCH_SUCCESS = "PLANT_SEARCH_SUCCESS"
export const PLANT_SEARCH_FAIL = "PLANT_SEARCH_FAIL"

export const GET_STRUCTURE_DATA = "GET_STRUCTURE_DATA"
export const GET_STRUCTURE_DATA_SUCCESS = "GET_STRUCTURE_DATA_SUCCESS"
export const GET_STRUCTURE_DATA_FAIL = "GET_STRUCTURE_DATA_FAIL"

export const GET_PLANT_DATA = "GET_PLANT_DATA"
export const GET_PLANT_DATA_SUCCESS = "GET_PLANT_DATA_SUCCESS"
export const GET_PLANT_DATA_FAIL = "GET_PLANT_DATA_FAIL"

export const GET_FREEBIE_PLANT_DATA = "GET_FREEBIE_PLANT_DATA"
export const GET_FREEBIE_PLANT_DATA_SUCCESS = "GET_FREEBIE_PLANT_DATA_SUCCESS"
export const GET_FREEBIE_PLANT_DATA_FAIL = "GET_FREEBIE_PLANT_DATA_FAIL"
